import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiSquareEditOutline } from "@mdi/js";
import CardShell from "./CardShell";

const openEditor = (reportId) =>
  window.open(`/reports/${reportId}/edit`, "_blank", "noopener,noreferrer");

// Start and Edit open the editor, which 404s without a report row.
const InspectionResultCard = ({ job, onSetup }) => {
  const count = job.inspection?.item_count || 0;
  const reportId = job.report_id;
  const isSetup = Boolean(job.job_setup?.is_setup);

  const renderBody = () => {
    if (!isSetup) {
      return (
        <>
          <div className="jd-inspection-empty">Job Setup required</div>
          <Button variant="primary" size="sm" onClick={onSetup}>
            Setup
          </Button>
        </>
      );
    }

    const editorButton = (label, variant) =>
      reportId && (
        <Button
          variant={variant}
          size="sm"
          onClick={() => openEditor(reportId)}
        >
          {label}
        </Button>
      );

    if (count === 0) {
      return (
        <>
          <div className="jd-inspection-empty">No items yet</div>
          {editorButton("Start", "primary")}
        </>
      );
    }

    return (
      <>
        <div>
          <div className="jd-inspection-count">{count}</div>
          <div className="jd-subtle">
            {count === 1 ? "Item" : "Items"} recorded
          </div>
        </div>
        {editorButton("Edit", "outline-primary")}
      </>
    );
  };

  return (
    <CardShell
      icon={
        <Icon path={mdiSquareEditOutline} size={0.7} className="jd-card-icon" />
      }
      title="Inspection Result"
      className="jd-card--half jd-inspection-card"
    >
      <div className="jd-inspection-row">{renderBody()}</div>
    </CardShell>
  );
};

export default InspectionResultCard;
